module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Soukromí",
	"footer.privacy.url": "https://www.grohe.cz/cs_cz/spolecnost/privacy.html",
	"footer.disclaimer.text": "Prohlášení",
	"footer.disclaimer.url": "https://www.grohe.cz/cs_cz/spolecnost/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Konfigurátor vodních systémů GROHE",
	"homepage.introtext": "Jednoduše odpovězte na pár otázek níže a získejte takovou konfiguraci vodního systému GROHE, jaká bude dokonale vyhovovat vašim požadavkům.",
	"homepage.buttonStart": "Spustit",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404: stránka nebyla nalezena",
	"404.link.goBack": "Přejít zpět na domovskou stránku",
	"configurator.button.seeResults": "Zobrazit výsledky",
	"question1.question": "Máte v kuchyni přípojku studené a teplé vody?",
	"question1.option1.text": "Ano, v kuchyni mám přípojku studené i teplé vody",
	"question1.option2.text": "V kuchyni mám pouze přípojku studené vody",
	"question2.question": "Jaký typ vody od vodního systému očekáváte?",
	"question2.option1.text": "vařící vodu pro přípravu pokrmů a horkých nápojů",
	"question2.option2.text": "Vychlazenou, perlivou vodu k pití",
	"question2.option3.text": "Vychlazenou a perlivou vodu, ale také vodu vařící",
	"question3.question": "Chcete si ponechat vaši stávající dřezovou baterii?",
	"question3.option1.text": "Chci si ji ponechat",
	"question3.option2.text": "Chci pořídit nový model",
	"question4.question": "Jaká by měla být vaše hlavní dřezová baterie?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Jaký tvar výpusti preferujete?",
	"question5.option1.text": "Výpusť ve tvaru písmene L",
	"question5.option2.text": "Výpusť ve tvaru písmene U",
	"question5.option3.text": "Výpusť ve tvaru písmene C",
	"question6.question": "Jaká povrchová úprava se vám líbí nejvíce?",
	"question6.option1.text": "Chromová",
	"question6.option2.text": "SuperSteel",
	"question7.question": "Jak velký bojler potřebujete?",
	"question7.option1.text": "Velikost M (3 litry)",
	"question7.option2.text": "Velikost L (5,5 litru)",
	"results.title": "{productGroupsCount, plural, \none {Váš výsledek} \nother {Vaše výsledky}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pro správnou instalaci budete potřebovat také:",
	"results.newConfiguration.title": "Chcete spustit konfiguraci nového vodního systému od začátku?",
	"results.newConfiguration.buttonText": "Spustit konfiguraci nového systému",
	"results.product.number": "Číslo produktu: #{number}",
	"results.product.button.productInformation": "Informace o produktu",
	"results.product.button.dealerLocator": "Najít showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Najít showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.cs_cz.json
// module id = 763
// module chunks = 0